(function () {
  class EbJournal extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-blog-tag]');
        if (link && window.fetch) this.loadTag(event, link.href);
      });
      window.addEventListener('popstate', () => this.renderUrl(window.location.href));
    }

    async loadTag(event, href) {
      event.preventDefault();
      window.history.pushState({}, '', href);
      await this.renderUrl(href);
    }

    async renderUrl(href) {
      const url = new URL(href, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);
      const html = await fetch(url.toString()).then((response) => response.text()).catch(() => '');
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('eb-journal');
      if (fresh) this.innerHTML = fresh.innerHTML;
    }
  }

  class EbArticle extends HTMLElement {
    connectedCallback() {
      this.progress = this.querySelector('[data-article-progress]');
      this.toc = this.querySelector('[data-article-toc]');
      this.mobileToc = this.querySelector('[data-article-toc-mobile]');
      this.content = this.querySelector('[data-article-content]');
      this.buildToc();
      this.bindProgress();
      this.bindShare();
    }

    buildToc() {
      if (!this.content || !this.toc) return;
      const headings = [...this.content.querySelectorAll('h2')];
      if (headings.length < 3) return;
      const links = headings.map((heading) => {
        if (!heading.id) heading.id = this.slug(heading.textContent);
        return `<a href="#${heading.id}">${this.escape(heading.textContent)}</a>`;
      }).join('');
      this.toc.innerHTML = links;
      this.toc.classList.add('is-visible');
      if (this.mobileToc) this.mobileToc.innerHTML = `<details><summary>${this.escape(this.dataset.tocLabel || 'Contents')}</summary>${links}</details>`;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.toc.querySelectorAll('a').forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${entry.target.id}`));
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      headings.forEach((heading) => observer.observe(heading));
    }

    bindProgress() {
      if (!this.progress) return;
      let ticking = false;
      const update = () => {
        ticking = false;
        const max = document.documentElement.scrollHeight - window.innerHeight;
        const ratio = max > 0 ? window.scrollY / max : 0;
        this.progress.style.transform = `scaleX(${Math.max(0, Math.min(1, ratio))})`;
      };
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }, { passive: true });
      update();
    }

    bindShare() {
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-article-copy]');
        if (!button) return;
        const original = button.textContent;
        try {
          await navigator.clipboard.writeText(window.location.href);
        } catch (error) {
          window.prompt('', window.location.href);
        }
        button.textContent = this.dataset.copiedLabel || original;
        window.setTimeout(() => { button.textContent = original; }, 1200);
      });
    }

    slug(value) {
      return String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || `section-${Math.random().toString(36).slice(2)}`;
    }

    escape(value) {
      return String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      })[char]);
    }
  }

  if (!customElements.get('eb-journal')) customElements.define('eb-journal', EbJournal);
  if (!customElements.get('eb-article')) customElements.define('eb-article', EbArticle);
})();
